import React, { useState } from 'react'
import { assets } from '../assets/assets'
import { FaWhatsapp } from "react-icons/fa6";
import { FaGoogle } from "react-icons/fa";
import { Link } from 'react-router-dom';


const Login = () => {
    const [currentState, SetCurrentState] = useState('Sign Up');

    const onSubmitHandler = async (e) => {
        e.preventDefault();
    }
    return (
        <div onSubmit={onSubmitHandler} className='login-section'>
            <div className="login_page" style={{ backgroundImage: `url(${assets.sign_up})` }}>
                <div className="p-3 p-xl-5">
                    <div className="login-form mt-5 mx-auto position-relative z-3">
                        <div className="title mb-5 text-center">{currentState}</div>
                        <form action="#" method="post" className="mt-5">
                            {currentState === 'Login' ? '' : <div className="mb-4">
                                <input type="text" name="email" className="form-control" required
                                    placeholder="Enter your email or phone Number" />
                            </div>}

                            <div className="mb-4">
                                <input type="text" name="email" className="form-control" required
                                    placeholder="Enter your emaill or phone" />
                            </div>
                            <div className="mb-4">
                                <input type="password" name="name" className="form-control" required placeholder="Password" />
                            </div>
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="remember_me">
                                    <div className="form-check">
                                        <input className="form-check-input" type="checkbox" value="" id="remember" />
                                        <label className="form-check-label" htmlFor="remember">
                                            Rememebr Me
                                        </label>
                                    </div>
                                </div>
                                <div className="forget_pass">
                                    <Link>Forget Password?</Link>
                                </div>
                            </div>
                            <div className="mb-4">
                                <button type="submit" className="login_btn btn btn-primary w-100">{currentState === 'Login' ? 'sign In' : 'Sign Up'}</button>
                            </div>
                            <div className="divider mb-4 d-flex align-items-center justify-content-center">
                                <div className="hr"></div>
                                <span>Or With</span>
                                <div className="hr"></div>
                            </div>
                            <div className="social_login mb-4">
                                <Link className="d-block w-100 btn btn-primary text-center mb-4 position-relative"
                                    style={{ backgroundColor: '#F8BC3D !important' }}>
                                    <FaWhatsapp />
                                    Login with Whatsapp
                                </Link>
                                <Link className="d-block w-100 btn btn-outline-dark text-center mb-4 position-relative">
                                    <FaGoogle />
                                    Login with google
                                </Link>
                            </div>

                            <div className="create_acc text-center">
                                {
                                    currentState === 'Login' ? <span onClick={() => SetCurrentState('Sign Up')} className="text-primary common-log">Create Account</span>
                                        : <span onClick={() => SetCurrentState('Login')} className="text-primary common-log">Login Here</span>
                                }
                                <Link to="/otp-login" className="text-primary common-log">
                                   {' '} | Use Otp Login
                                </Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Login
